import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
  Link,
} from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';
import Lightbox from 'react-image-lightbox';

import {
  CircularProgress,
  Grid,
  Typography,
  Button,
} from '@material-ui/core';

import Alert from '../../common/components/Alert';
import MainLayout from '../../common/components/MainLayout';

import * as mainActions from '../actions';
import classes from '../../css/getCSS';
import * as routes from '../../config/routes';
import * as constants from '../../config/constants';

class GalleryDetail extends Component {
  state = {
    modalOpen: false,
    imageIndex: null,
  }

  componentDidMount() {
    document.title = 'Loading album...';
    window.scrollTo(0, 0);
    this.props.getGalleryItem(
      this.props.match.params.slug,
    );
  }

  componentWillUnmount() {
    this.props.deepUnmount();
  }

  handleClose = () => {
    this.setState({
      modalOpen: false,
    });
  }

  previewImage = (index) => {
    this.setState({
      modalOpen: true,
      imageIndex: index,
    });
  }

  render() {
    if (this.props.currentAlbum) {
      document.title = this.props.currentAlbum.title;
    }

    let loading = null;

    if (this.props.loading) {
      loading = (
        <div align="center" style={{ marginTop: '50px' }}>
          <CircularProgress align="center" size={50} /> <br />
          <Typography variant="body1">Loading. Please wait</Typography>
        </div>
      );
    }

    let errorAlert = null;
    if (this.props.error) {
      errorAlert = <Alert type="danger">{this.props.error}</Alert>;
    }

    let content = null;
    let title = null;
    const photosArr = [];
    if (this.props.currentAlbum) {
      const album = this.props.currentAlbum;

      title = (
        <Typography variant="headline">{album.title}</Typography>
      );

      content = this.props.currentAlbum.photos.map((val, index) => {
        const src = constants.BASE_URL + val.thumbnail;
        photosArr.push(val.file);
        return (
          <Grid
            item
            md={2}
            sm={3}
            xs={6}
            onClick={() => this.previewImage(index)}
            key={val.id}
          >
            <img alt={val.slug} src={src} style={{ width: '100%', height: '100%' }} />
          </Grid>
        );
      });
    }

    let rootClass = null;
    if (this.props.token) {
      rootClass = classes.dashboardLayout;
    }

    return (
      <MainLayout rootClass={rootClass} isAuthenticated={this.props.token !== null}>
        <br />
        <Link className={classes.linkDeCSS} to={formatRoute(routes.GALLERY)}>
          <Button variant="contained" color="default">Back to all albums</Button>
        </Link>
        <br /><br />
        {loading}
        {errorAlert}
        {title}
        <br />
        <Grid container spacing={16}>
          {content}
        </Grid>
        {this.state.modalOpen && (
          <Lightbox
            mainSrc={photosArr[this.state.imageIndex]}
            nextSrc={photosArr[(this.state.imageIndex + 1) % photosArr.length]}
            prevSrc={photosArr[(this.state.imageIndex + photosArr.length - 1) % photosArr.length]}
            onCloseRequest={() => this.setState({ modalOpen: false })}
            onMovePrevRequest={() => this.setState({
              imageIndex: (this.state.imageIndex + photosArr.length - 1) % photosArr.length,
            })}
            onMoveNextRequest={() => this.setState({
              imageIndex: (this.state.imageIndex + 1) % photosArr.length,
            })}
          />
        )}
      </MainLayout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    site: state.common.site,
    token: state.auth.token,
    loading: state.main.loading,
    error: state.main.error,
    currentAlbum: state.main.currentAlbum,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUnmount: () => dispatch(mainActions.onUnmount()),
    deepUnmount: () => dispatch(mainActions.deepUnmount()),
    getGalleryItem: slug => dispatch(mainActions.getGalleryItem(slug)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GalleryDetail));



// WEBPACK FOOTER //
// ./src/main/containers/GalleryDetail.js